<template lang="">
  <v-list-item
    class="itemStyle"
    :key="item._id"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list-item-avatar size="25">
      <v-img :src="item.source"></v-img>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        {{ item.contact_lead_name }}
      </v-list-item-title>

      <v-list-item-subtitle v-if="item.budget > 0"
        >Presupuesto:

        <span class="green--text text--darken-4">
          {{ budgetFormat(item) }}
        </span>
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        Creado: {{ formatDate(item.created_at) }}
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        Actualizado: {{ formatDate(item.updated_at) }}
      </v-list-item-subtitle>
      <span v-if="item.discard_observations" class="pt-1 font-weight-medium">
        Motivo de descarte: {{ item.discard_observations }}
      </span>
    </v-list-item-content>

    <v-list-item-icon>
      <div
        style="display: flex; justify-content: space-between; align-items: center; gap: 0.5rem;"
      >
        <LeadCategoryIcon
          v-if="item.category"
          :code="item.category.code"
          :color="item.category.color"
          size="18px"
        />
        <lead-postpone-action
          :postponed="item.postponed?.date_at"
          :leadId="item._id"
          :lead="item"
        />
      </div>
    </v-list-item-icon>
  </v-list-item>
</template>
<script>
import { getRelativeTimeString } from "../../../../helpers/date/relativeTime";
export default {
  name: "ListLeadItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      money: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0
      })
    };
  },
  components: {
    LeadPostponeAction: () => import("@/components/lead/LeadPostpone"),
    LeadCategoryIcon: () =>
      import(
        "@/components/lead/components/LeadSelectCategory/LeadCategoryIcon.vue"
      )
  },
  methods: {
    budgetFormat(item) {
      if (item.budget === 0) {
        return "-";
      } else {
        return (
          this.money.format(item.budget) +
          " " +
          (item.currency ? item.currency : "MXN")
        );
      }
    },
    formatDate(date) {
      if (!date) return "-";
      return getRelativeTimeString(new Date(date));
    }
  }
};
</script>
<style lang=""></style>
